function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { getRmCopilotSendMessagePayload, convertRmCopilotResponseToConversation, getFeedbackPayload, RM_COPILOT_NAME } from 'api/rm-copilot/utils';
import { CONVERSATION_SERVICE_URL } from 'config/environment';
export class RmCopilotHttpClient extends HttpClient {
    async sendMessage({ message, conversationId, accountId, userId, conversation_metadata, sectionType, message_sections }) {
        var _data_success, _data_error_message;
        const payload = getRmCopilotSendMessagePayload({
            message,
            conversationId,
            accountId,
            userId,
            sectionType,
            conversation_metadata,
            message_sections
        });
        const data = await this.post('/chat', payload);
        return {
            conversation_id: conversationId,
            message_id: data.message_id,
            chat_stream_id: data.chat_stream_id,
            token: data.token || '',
            success: (_data_success = data.success) !== null && _data_success !== void 0 ? _data_success : true,
            error_message: (_data_error_message = data.error_message) !== null && _data_error_message !== void 0 ? _data_error_message : null
        };
    }
    async getAllConversations(params) {
        const { offset, limit } = params;
        const config = {
            params: {
                page: offset === 0 ? '1' : (offset / limit + 1).toString(),
                page_size: limit.toString(),
                agent_name: RM_COPILOT_NAME
            }
        };
        const data = await this.get('/chat/conversations', config);
        return data;
    }
    async getConversation(conversationId) {
        try {
            const responseData = await this.get(`/chat/conversations/${conversationId}`);
            return convertRmCopilotResponseToConversation(responseData);
        } catch (error) {
            var _error_response_data, _error_response;
            const errorMessage = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Error fetching conversation';
            throw new Error(errorMessage, {
                cause: error
            });
        }
    }
    async deleteConversation(conversationId) {
        await this.delete(`/chat/conversations/${conversationId}`);
    }
    async sendFeedback({ messageId, accountId, userId, feedbackType, feedbackCategory, feedbackText }) {
        const payload = getFeedbackPayload({
            messageId,
            accountId,
            userId,
            feedbackType,
            feedbackCategory,
            feedbackText
        });
        await this.post('/chat/feedback', payload);
    }
    async updateFeedback({ messageId, accountId, userId, feedbackType, feedbackCategory, feedbackText }) {
        const payload = getFeedbackPayload({
            messageId,
            accountId,
            userId,
            feedbackType,
            feedbackCategory,
            feedbackText
        });
        await this.put('/chat/feedback', payload);
    }
}
_define_property(RmCopilotHttpClient, "getStreamUrl", (streamId)=>{
    return `${CONVERSATION_SERVICE_URL}/api/v1/chat/stream/${streamId}`;
});
export const rmCopilotHttpClient = new RmCopilotHttpClient();
